import { isMobileStyleMixin, TextButton, Text } from '@amzn/storm-ui';
import styled, { css } from 'styled-components';
import { focusNavElementMixin } from '../../../nav/components/styles';

export const ContextBarWrapper = styled.div`
  display: flex;
  padding: ${({ theme }) => theme.spacing.medium};
  flex-grow: 1;
  justify-content: start;
  overflow: hidden;
  padding-right: 0;
  ${isMobileStyleMixin(css`
    align-items: center;
    padding: ${({ theme }) => theme.spacing.small};
  `)}
`;

export const MobileMenuButton = styled(TextButton)`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px 11px;
  color: ${({ theme }) => theme.palette.white};
  margin-inline-end: ${({ theme }) => theme.spacing.base};
  &:hover,
  &:active {
    color: ${({ theme }) => theme.palette.white};
  }
  ${focusNavElementMixin}
`;

export const MobileMenuButtonIcon = styled.svg`
  width: 18px;
  height: 16px;

  & > path {
    fill: ${({ theme }) => theme.palette.white};
  }
`;

export const BreadcrumbsPageName = styled(Text)<{ ia2Enabled?: boolean }>`
  ${isMobileStyleMixin(css`
    font-size: 15px;
  `)}
  font-weight: bold;
  display: inline-block;
  white-space: nowrap;
`;

export const PageHeaderSectionWrapper = styled.a`
  display: flex;
  align-items: center;
  text-decoration: none;
  &:hover {
    text-decoration: none;
  }
`;

export const AppNameSectionWrapper = styled.span<{
  showDivider: boolean | undefined;
}>`
  display: flex;
  ${({ showDivider }) => {
    if (showDivider) {
      return css`
        // hide border when context bar is rendered below header
        @media (max-width: 1000px) {
          border-inline-start: none;
        }
        border-inline-start: 1px solid black;
      `;
    }
  }}
  padding-inline-start: ${({ theme }) => theme.spacing.medium};
  padding-inline-end: ${({ theme }) => theme.spacing.base};
  margin-inline-start: -${({ theme }) => theme.spacing.medium};
`;

export const CategoryTitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  color: white;

  & span[class*='Tag-sc-storm-ui'] {
    bottom: 1px;
  }
`;

export const IconWrapper = styled.div`
  margin-inline-end: ${({ theme }) => theme.spacing.base};
`;
